import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  getCurrentInstance,
  ref,
  onBeforeMount,
  onBeforeUnmount
} from 'vue'
import { useRouter } from 'vue-router/composables'
import { useEventListener } from '@vueuse/core'
import { emitter, OPEN_ACCOUNT_DIALOG } from '@/plugins/emitter'
import { useAuth } from '@/composables/useAuth'
import LoginForms from '@/components/LoginForms.vue'

type YagiClient = {
  isYagiDaikon: boolean
  profile: {
    name: string
    color: string
    autoSaveEnabled: boolean
  }
  changeColor: (color: string) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDialog',
  setup(__props) {

/**
 * 設定ダイアログ（vue-final-modal）。
 * open は mitt（`emitOpenAccountDialog`）。
 * 戻る操作は window popstate（VueUse）。event bus / vue-js-modal は使わない。
 */
const vm = getCurrentInstance()!.proxy as unknown as {
  $yagi: YagiClient
  $deviceLib: { isOnline: boolean }
}

const yagi = vm.$yagi
const deviceLib = vm.$deviceLib
const router = useRouter()

const YAGI_COLORS = [
  'white',
  '#D7D7D7',
  '#E0D0B6',
  '#E3C9C2',
  '#FFD0F6',
  '#ffffb7',
  '#b7ffb7',
  '#c1c1ff',
  '#1A5234',
  'lightcyan',
  'skyblue',
  'plum',
  'gold'
] as const

const yagiColors = YAGI_COLORS

const yagiRules = {
  name: [
    {
      required: true,
      message: '名前をいれてね',
      trigger: 'change'
    },
    {
      min: 1,
      max: 16,
      message: '16文字以内にしてね',
      trigger: 'change'
    }
  ]
}

const visible = ref(false)
const { user, isAuthenticated, signOut } = useAuth()
const getMode = computed(() => process.env.VUE_APP_MODE)
const userDisplayName = computed(() => user.value?.displayName || '')
const userEmail = computed(() => user.value?.email || '')

function openDialog() {
  visible.value = true
}

function closeDialog() {
  visible.value = false
}

function onVisibleInput(value: boolean) {
  visible.value = value
}

function onSignOut(event: Event) {
  signOut()
  event.preventDefault()
}

useEventListener(window, 'popstate', closeDialog)

onBeforeMount(() => {
  emitter.on(OPEN_ACCOUNT_DIALOG, openDialog)
})

onBeforeUnmount(() => {
  emitter.off(OPEN_ACCOUNT_DIALOG, openDialog)
})

return { __sfc: true,vm, yagi, deviceLib, router, YAGI_COLORS, yagiColors, yagiRules, visible, user, isAuthenticated, signOut, getMode, userDisplayName, userEmail, openDialog, closeDialog, onVisibleInput, onSignOut, LoginForms }
}

})